import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row pt-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Attending Physician")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician's name or NPI in the respective search field. ", -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group col-12 d-flex flex-column mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_7 = { class: "col-12 flex-row py-2 px-3 row g-0" }
const _hoisted_8 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_12 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Search", -1 /* HOISTED */)
const _hoisted_14 = { class: "col-12 flex-row px-3 py-2 row g-0 align-items-center" }
const _hoisted_15 = { class: "form-group col-12 col-lg-4" }
const _hoisted_16 = { for: "patient-first-name" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Attending Physician ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_19 = {
  class: "px-1",
  tabindex: "0",
  role: "button"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle text-dark font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_23 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_25 = { class: "physician-information mb-3" }
const _hoisted_26 = { class: "me-1" }
const _hoisted_27 = { class: "me-1" }
const _hoisted_28 = { class: "me-1" }
const _hoisted_29 = { class: "me-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt me-1" }, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fax me-1" }, null, -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope me-1 me-1" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "form-check custom-checkbox mb-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "physicianContacted"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "The attending physician agreed to provide ongoing care for the patient.")
], -1 /* HOISTED */)
const _hoisted_35 = {
  tabindex: "0",
  role: "button"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle text-dark font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-3 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Other Physicians on the Case")
], -1 /* HOISTED */)
const _hoisted_41 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_42 = { class: "my-2 d-flex align-items-center font-size-md" }
const _hoisted_43 = { class: "me-2" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician's name or NPI in the respective search field. ", -1 /* HOISTED */)
const _hoisted_48 = { class: "form-group col-12 d-flex flex-column mb-0" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_50 = { class: "col-12 flex-row py-2 px-3 row g-0" }
const _hoisted_51 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_53 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_55 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Search", -1 /* HOISTED */)
const _hoisted_57 = { class: "col-12 flex-row px-3 py-2 row g-0 align-items-center" }
const _hoisted_58 = { class: "form-group col-12 col-lg-4" }
const _hoisted_59 = { for: "patient-first-name" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Attending Physician ")
const _hoisted_61 = {
  tabindex: "0",
  role: "button"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle text-dark font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_65 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_67 = { class: "physician-information mb-3" }
const _hoisted_68 = { class: "me-1" }
const _hoisted_69 = { class: "me-1" }
const _hoisted_70 = { class: "me-1" }
const _hoisted_71 = { class: "me-1" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt me-1" }, null, -1 /* HOISTED */)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fax me-1" }, null, -1 /* HOISTED */)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope me-1 me-1" }, null, -1 /* HOISTED */)
const _hoisted_75 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Physicians",
    type: "his-section",
    "full-height": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getReferringPhysicianListItem,
                  onValueChanged: _ctx.referringPhysicianFiltersCity,
                  "results-limit": 1,
                  itemName: "city",
                  placeholder: "Select City"
                }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getReferringPhysicianListItem,
                  onValueChanged: _ctx.referringPhysicianFiltersState,
                  "results-limit": 2,
                  itemName: "state",
                  placeholder: "Select State"
                }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, _hoisted_21)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.attendingPhysicianTooltip) }]
                  ])
                ]),
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getPhysicianList,
                  onValueChanged: _ctx.attendingPhysicianChanged,
                  placeholder: "Start Typing...",
                  value: _ctx.attendingPhysician,
                  isError: _ctx.attendingPhysicianError
                }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value", "isError"])
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getReferringPhysicianListItem,
                  onValueChanged: _ctx.referringPhysicianFiltersNpiChange,
                  "results-limit": 3,
                  itemName: "npi",
                  "key-updated": _ctx.npiChanged('referring'),
                  placeholder: "Search By NPI"
                }, null, 8 /* PROPS */, ["getData", "onValueChanged", "key-updated"])
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", null, "Physician Name: " + _toDisplayString(_ctx.physicianInfo.DisplayName) + ",", 1 /* TEXT */),
            _createElementVNode("p", null, "NPI: " + _toDisplayString(_ctx.physicianInfo.NPI), 1 /* TEXT */),
            _createElementVNode("p", null, "Address: " + _toDisplayString(_ctx.physicianInfo.AddressLine1) + ",", 1 /* TEXT */),
            _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.physicianInfo.AddressLine2) + ",", 513 /* TEXT, NEED_PATCH */), [
              [_vShow, _ctx.physicianInfo.AddressLine2]
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.physicianInfo.AddressCity) + ",", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.physicianInfo.AddressStateCode) + ",", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.physicianInfo.AddressZipCode) + ",", 1 /* TEXT */)
            ]),
            _createElementVNode("p", null, [
              _withDirectives(_createElementVNode("span", _hoisted_29, [
                _hoisted_30,
                _createTextVNode("Phone:" + _toDisplayString(_ctx.physicianInfo.PhoneWork), 1 /* TEXT */)
              ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.physicianInfo.PhoneWork]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_31,
                _createTextVNode(", Fax: " + _toDisplayString(_ctx.physicianInfo.FaxNumber), 1 /* TEXT */)
              ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.physicianInfo.FaxNumber]
              ])
            ]),
            _withDirectives(_createElementVNode("p", null, [
              _hoisted_32,
              _createTextVNode("Email Address: " + _toDisplayString(_ctx.physicianInfo.EmailAddress), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.physicianInfo.EmailAddress]
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.physicianInfo.FirstName]
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "physicianContacted",
              class: "form-check-input au-target",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Physicians.IsPhysicianContacted) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.referral.Physicians.IsPhysicianContacted]
            ]),
            _hoisted_34,
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_35, _hoisted_37)), [
              [_directive_custom_popover, {
                                content: _ctx.sanitizeMarkup(_ctx.attendingPhysicianContactedTooltip)
                            }]
            ])
          ]),
          _createElementVNode("section", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-xs btn-primary mb-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openNewPhysicianDialog()))
            }, " New Physician ")
          ]),
          _createElementVNode("section", _hoisted_39, [
            _hoisted_40,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referral.Physicians.AgencyPhysicianDetails, (physician, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_FormSection, {
                  "application-id": _ctx.application,
                  type: "his-section"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("b", _hoisted_43, "Additional Physician " + _toDisplayString(index + 1), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "btn table-btn btn-outline-danger me-1 ms-auto",
                          onClick: ($event: any) => (_ctx.removeAdditionalPhysician(index))
                        }, _hoisted_46, 8 /* PROPS */, _hoisted_44)
                      ]),
                      _hoisted_47,
                      _createElementVNode("section", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("section", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createVNode(_component_TypeaheadInput, {
                              getData: _ctx.getReferringPhysicianListItem,
                              onValueChanged: _ctx.referringPhysicianFiltersCity,
                              "results-limit": 1,
                              itemName: "city",
                              placeholder: "Select City"
                            }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createVNode(_component_TypeaheadInput, {
                              getData: _ctx.getReferringPhysicianListItem,
                              onValueChanged: _ctx.referringPhysicianFiltersState,
                              "results-limit": 2,
                              itemName: "state",
                              placeholder: "Select State"
                            }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
                          ])
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("section", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, [
                              _hoisted_60,
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_61, _hoisted_63)), [
                                [_directive_custom_popover, {
                                                                content: _ctx.sanitizeMarkup(_ctx.attendingPhysicianTooltip)
                                                            }]
                              ])
                            ]),
                            _createVNode(_component_TypeaheadInput, {
                              getData: _ctx.getPhysicianList,
                              onValueChanged: ($event: any) => (_ctx.otherPhysicianChanged($event, index)),
                              placeholder: "Start Typing...",
                              "init-value": _ctx.otherPhysicians[index]
                            }, null, 8 /* PROPS */, ["getData", "onValueChanged", "init-value"])
                          ]),
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _hoisted_66,
                            _createVNode(_component_TypeaheadInput, {
                              getData: _ctx.getReferringPhysicianListItem,
                              onValueChanged: ($event: any) => (
                                                            _ctx.referringPhysicianFiltersNpiChange($event, index)
                                                        ),
                              "results-limit": 3,
                              itemName: "npi",
                              placeholder: "Search By NPI"
                            }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_67, [
                        _createElementVNode("p", null, "Physician Name: " + _toDisplayString(_ctx.additionalPhysicians[index]?.DisplayName) + ",", 1 /* TEXT */),
                        _createElementVNode("p", null, "NPI: " + _toDisplayString(_ctx.additionalPhysicians[index]?.NPI), 1 /* TEXT */),
                        _createElementVNode("p", null, "Address: " + _toDisplayString(_ctx.additionalPhysicians[index]?.AddressLine1) + ",", 1 /* TEXT */),
                        _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.additionalPhysicians[index]?.AddressLine2) + ", ", 513 /* TEXT, NEED_PATCH */), [
                          [_vShow, _ctx.additionalPhysicians[index]?.AddressLine2]
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.additionalPhysicians[index]?.AddressCity) + ",", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.additionalPhysicians[index]?.AddressStateCode) + ",", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.additionalPhysicians[index]?.AddressZipCode) + ",", 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", null, [
                          _withDirectives(_createElementVNode("span", _hoisted_71, [
                            _hoisted_72,
                            _createTextVNode("Phone: " + _toDisplayString(_ctx.additionalPhysicians[index]?.PhoneWork), 1 /* TEXT */)
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.additionalPhysicians[index]?.PhoneWork]
                          ]),
                          _withDirectives(_createElementVNode("span", null, [
                            _hoisted_73,
                            _createTextVNode(", Fax: " + _toDisplayString(_ctx.additionalPhysicians[index]?.FaxNumber), 1 /* TEXT */)
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.additionalPhysicians[index]?.FaxNumber]
                          ])
                        ]),
                        _withDirectives(_createElementVNode("p", null, [
                          _hoisted_74,
                          _createTextVNode("Email Address: " + _toDisplayString(_ctx.additionalPhysicians[index]?.EmailAddress), 1 /* TEXT */)
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, _ctx.additionalPhysicians[index]?.EmailAddress]
                        ])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.additionalPhysicians[index]?.FirstName]
                      ])
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["application-id"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createElementVNode("button", {
              class: "btn btn-xs btn-primary mb-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addAdditionalPhysician())),
              disabled: _ctx.additionalPhysicianIndex >= 10
            }, " Add ", 8 /* PROPS */, _hoisted_75)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}